import { render } from "./SICanvas.vue?vue&type=template&id=5bdd4c9c"
import script from "./SICanvas.vue?vue&type=script&lang=js"
export * from "./SICanvas.vue?vue&type=script&lang=js"
script.render = render

export default script